import { Border, CARD_NOSE_SHIFT_Y, NOSE_WIDTH, SECTION_PROPORTION_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ICardProps } from "../Card"
import { useEffect, useMemo, useState } from "react"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { Color } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */ 
const CardBorderNose = (props: ICardProps): JSX.Element => {
    const {data, section, contentData} = props
    const sizes = useScreenSize()
    const border: Border = contentData.border
    const noseWidth = NOSE_WIDTH
    const border_radius: number[] = useMemo<number[]>(() => {
        return Array.isArray(contentData.border_radius)
            ?
            contentData.border_radius
            :
            Array(4).fill("").map(() => contentData.border_radius || 2)
    }, [contentData.border_radius])

    const gap = contentData.gap || 0
    const [w, setW] = useState<number>( 0 )
    const [h, setH] = useState<number>( 0 )
    const [top, setTop] = useState<number>( 0 )
    const [left, setLeft] = useState<number>( 0 )
    const [round, setRound] = useState<number[]>( border_radius )
    const strokeW: number = border?.strokeWidth || 0
    const color: Color = border?.stroke || ""

    useEffect(() => {
        setTimeout(() => {
            const selector = `.landing-card-body-${data.id}`
            const elem: Element = document.querySelector(selector)!
            if(!!elem) {
                const bounds: DOMRect = elem?.getBoundingClientRect() || {}             
                const style = window.getComputedStyle( elem )
                setTop( parseInt(style.getPropertyValue('margin-top')) || 0 ) 
                setW(bounds.width)
                setH(bounds.height)
            }
        }, 100)
    }, [ sizes ])

    const s = strokeW / 2
    const x = s + noseWidth
    const svgWidth  = w + strokeW + noseWidth * 2
    const svgHeight = h + strokeW + noseWidth * 2

    return <>
        <svg 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width={ svgWidth }
            height={ svgHeight }
            viewBox={`0 0 ${ svgWidth } ${ svgHeight }`}
            xmlSpace="preserve"
            className="untouchble position-absolute z-index-3 "
            style={{
                top:  - x,
                left: - x,
            }}
        >
            <path
                fill="transparent"
                stroke={ color }
                strokeWidth={ strokeW }
                d={`
                    M${round[1] + x} ${x},
                    L${w - round[1] + x} ${x},
                    Q${w + x} ${x} ${w + x} ${round[2] + x}, `   +                
                    
                    ( border?.noseDistination === SECTION_PROPORTION_TYPE.RIGHT
                        ?
                        `L${w + x} ${ x + CARD_NOSE_SHIFT_Y + gap / 2 - noseWidth - noseWidth },
                        L${w + x + noseWidth} ${ x + CARD_NOSE_SHIFT_Y + gap / 2 - noseWidth },
                        L${w + x} ${ x + CARD_NOSE_SHIFT_Y + gap / 2 + noseWidth - noseWidth },`
                        :
                        ``) 
                        +

                    `L${w + x} ${h - round[2] + x},
                    Q${w + x} ${h + x} ${w + x - round[3]} ${h + x},
                    L${round[3] + x} ${h + x},
                    Q${x} ${h + x} ${x} ${h - round[3] + x},` +
                    
                    ( border?.noseDistination === SECTION_PROPORTION_TYPE.LEFT
                        ?
                        `L${x} ${ x + CARD_NOSE_SHIFT_Y + gap / 2 + noseWidth - noseWidth },
                        L${x - noseWidth} ${ x + CARD_NOSE_SHIFT_Y + gap / 2 - noseWidth },
                        L${x} ${ x + CARD_NOSE_SHIFT_Y + gap / 2 - noseWidth - noseWidth },` 
                        :
                        ``)    
                    +

                    `L${x} ${round[0] +x}, 
                    Q${x} ${x} ${round[0] + x} ${x}
                    Z
                `}
            />
        </svg>
    </>
}
export default CardBorderNose